import React from "react";
import Heading from "../../common/Heading";
import "./product.css"; // Import CSS for styling

const Product = () => {
  return (
    <>
      <section className="product-section padding">
        <div className="container">
          {/* Page Heading */}
          <Heading title="Our Products" subtitle="Explore our high-quality aluminum and partitioning products." />

          {/* Product Grid */}
          <div className="product-grid">
            {/* Product 1 - Aluminum Window */}
            <div className="product-card">
              <img src="../images/product1.jpg" alt="" />
              <h3>Aluminum Window</h3>
              <p className="price">$120</p>
              <p className="description">
                High-quality aluminum windows designed for durability, security, and energy efficiency. Ideal for residential and commercial properties.
              </p>
              <ul className="features">
                <li>Rust-resistant aluminum frame</li>
                <li>Double-glazed glass for insulation</li>
                <li>Modern and sleek design</li>
                <li>Available in different sizes and colors</li>
              </ul>
            </div>

            {/* Product 2 - Glass Partition */}
            <div className="product-card">
              <img src="../images/product2.jpg" alt="" />
              <h3>Glass Partition</h3>
              <p className="price">$200</p>
              <p className="description">
                Stylish glass partitions perfect for modern offices, retail stores, and homes, offering a balance of openness and privacy.
              </p>
              <ul className="features">
                <li>Tempered glass for durability</li>
                <li>Soundproof and elegant design</li>
                <li>Easy to install and maintain</li>
                <li>Customizable frame colors</li>
              </ul>
            </div>

            {/* Product 3 - Gypsum Board */}
            <div className="product-card">
              <img src="../images/product3.jpg" alt="" />
              <h3>Gypsum Board</h3>
              <p className="price">$80</p>
              <p className="description">
                High-quality gypsum boards used for ceilings and walls, providing excellent fire resistance and sound insulation.
              </p>
              <ul className="features">
                <li>Lightweight and easy to install</li>
                <li>Fire-resistant and soundproof</li>
                <li>Ideal for ceilings and partitions</li>
                <li>Smooth surface for painting and decoration</li>
              </ul>
            </div>

            {/* Product 4 - Aluminum Door */}
            <div className="product-card">
              <img src="../images/product4.jpg" alt="" />
              <h3>Aluminum Door</h3>
              <p className="price">$150</p>
              <p className="description">
                Strong and stylish aluminum doors that offer security, weather resistance, and a modern aesthetic for homes and offices.
              </p>
              <ul className="features">
                <li>Corrosion-resistant aluminum frame</li>
                <li>Customizable designs and finishes</li>
                <li>Weatherproof and long-lasting</li>
                <li>High-security locking system</li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Product;
